var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90002 6.25546C6.90002 5.78295 7.28307 5.3999 7.75558 5.3999H18.0222C18.4948 5.3999 18.8778 5.78295 18.8778 6.25546C18.8778 6.72797 18.4948 7.11101 18.0222 7.11101H7.75558C7.28307 7.11101 6.90002 6.72797 6.90002 6.25546Z",
    fill: "#33383F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90002 10.5333C6.90002 10.0608 7.28307 9.67773 7.75558 9.67773H18.0222C18.4948 9.67773 18.8778 10.0608 18.8778 10.5333C18.8778 11.0058 18.4948 11.3888 18.0222 11.3888H7.75558C7.28307 11.3888 6.90002 11.0058 6.90002 10.5333Z",
    fill: "#33383F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90002 14.8111C6.90002 14.3386 7.28307 13.9556 7.75558 13.9556H18.0222C18.4948 13.9556 18.8778 14.3386 18.8778 14.8111C18.8778 15.2836 18.4948 15.6667 18.0222 15.6667H7.75558C7.28307 15.6667 6.90002 15.2836 6.90002 14.8111Z",
    fill: "#33383F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18889 6.25546C5.18889 6.72797 4.80585 7.11101 4.33334 7.11101C3.86083 7.11101 3.47778 6.72797 3.47778 6.25546C3.47778 5.78295 3.86083 5.3999 4.33334 5.3999C4.80585 5.3999 5.18889 5.78295 5.18889 6.25546Z",
    fill: "#33383F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18889 10.5333C5.18889 11.0058 4.80585 11.3888 4.33334 11.3888C3.86083 11.3888 3.47778 11.0058 3.47778 10.5333C3.47778 10.0608 3.86083 9.67773 4.33334 9.67773C4.80585 9.67773 5.18889 10.0608 5.18889 10.5333Z",
    fill: "#33383F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18889 14.8111C5.18889 15.2836 4.80585 15.6667 4.33334 15.6667C3.86083 15.6667 3.47778 15.2836 3.47778 14.8111C3.47778 14.3386 3.86083 13.9556 4.33334 13.9556C4.80585 13.9556 5.18889 14.3386 5.18889 14.8111Z",
    fill: "#33383F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list_icon.1ce3e4dd28f7ef491edb3711c7819da0.svg";
export { ForwardRef as ReactComponent };